module.exports = __webpack_public_path__ + "static/img/baner3.a7056a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/baner3.png
// module id = bgCJ
// module chunks = 0